// Func = limiting Scope for this file
var lastScrollTop = 0;

function _get_form_token(){
	$.get(
		site_url + '/ajax/functions.php?operation=_get_form_token',
		function(resp) {
			$("input[name=_token][type=hidden]").each( function(){
				this.value = resp
			})		
		}		
	);
}


(function () {
	_get_form_token();
	$(document).ready(function () {
		if ($('.two_cards').length > 0) {
			setTimeout(function () {
				$('.two_cards .two_cards__item').each(function () {
					$(this).on('click', function (e) {
						if ($(this).hasClass('active')) {
							$(this).removeClass('active');
						} else {
							$(this).addClass('active');
						}
					});
				});
			}, 100);
		}
		if ($('.specials_block').length > 0) {
			setTimeout(function () {
				$('.specials_block .specials_block__item').each(function () {
					$(this).on('click', function (e) {
						if ($(this).hasClass('active')) {
							$(this).removeClass('active');
						} else {
							$(this).addClass('active');
						}
					});
				});
			}, 100);
		}
		if ($('.gallery-block').length > 0) {
			setTimeout(function () {
				$('.gallery-block .gallery-block__image').each(function () {
					$(this).on('click', function (e) {
						if ($(this).hasClass('active')) {
							$(this).removeClass('active');
						} else {
							$(this).addClass('active');
						}
					});
				});
			}, 100);
		}

		//tablet menu
		if (document.getElementById('tabletBurger')) {
			document.getElementById('tabletBurger').addEventListener('click', function () {
				if (!document.getElementById('primary-nav').classList.contains('open')) {
					document.getElementById('primary-nav').classList.add('open');
					this.classList.add('open');
				} else {
					document.getElementById('primary-nav').classList.remove('open');
					this.classList.remove('open');
				}
			});
		}

		/* Location Overview */
		var locationDots = document.querySelectorAll('.locationMod_pin');

		$('.locationMod_list').on('beforeChange', function () {
			locationDots.forEach((pin) => {
				pin.classList.remove('active');
			});
		});
		$('.locationMod_list').on('afterChange', function (a, b, c) {
			let selectorString = `#locationMod_pin-${c}`;
			document.querySelector(selectorString).classList.add('active');
		});

		// Desplegable menu MOBILE
		// Open
		$(' #mobile-menu-button ').on('click', function (e) {
			e.preventDefault();
			$(this).addClass('opened');
			$('.mobile-navigation').addClass('opened');
		});
		// Close
		$(' .close-menu-js ').on('click', function (e) {
			$('#mobile-menu-button').removeClass('opened');
			$('.mobile-navigation').removeClass('opened');

			$('#primary-nav').removeClass('open');
		});

		//  Rooms Block
		let Tabs = document.getElementsByClassName('rooms_overview__tab');
		let tabsLenght = Tabs.length;

		for (let i = 0; i < tabsLenght; i++) {
			Tabs[i].addEventListener('click', function () {
				for (let i = 0; i < tabsLenght; i++) {
					Tabs[i].classList.remove('active');
				}
				this.classList.add('active');
				this.setAttribute("aria-selected", "true");

				let rooms = document.querySelectorAll('.each_room');
				let rooms_total = rooms.length;
				let ref = this.dataset.ref;

				for (let j = 0; j < rooms_total; j++) {
					rooms[j].classList.remove('active');
					rooms[j].setAttribute("aria-selected", "false");
				}

				document.querySelector('.id_' + ref).classList.add('active');
			});
		}
		//  Detail Button
		let rooms_details = document.getElementsByClassName('details');
		let rooms_detailsLenght = rooms_details.length;

		for (let i = 0; i < rooms_detailsLenght; i++) {
			rooms_details[i].addEventListener('mouseenter', function () {
				this.classList.add('active');
			});
			rooms_details[i].addEventListener('mouseleave', function () {
				this.classList.remove('active');
			});
		}

		(function (i, s, o, g, r, a, m) {
			i['GoogleAnalyticsObject'] = r;
			(i[r] =
				i[r] ||
				function () {
					(i[r].q = i[r].q || []).push(arguments);
				}),
				(i[r].l = 1 * new Date());
			(a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
			a.async = 1;
			a.src = g;
			m.parentNode.insertBefore(a, m);
		})(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

		$('#booking-form').submit(function (event) {
			//NEW LANDING PAGE WIDGET ID ADDED
			event.preventDefault();
			//var promoCode = jQuery(this).find('[name="promo_code"]').val();
			var form = $(this).attr('id');
			var promoCode = '';
			if ($('#' + form + ' input[name="promo"]').length > 0) {
				promoCode = $('#' + form + ' input[name="promo"]').val();
			}
			if ($('#' + form + ' input[name="promo_code"]').length > 0) {
				promoCode = $('#' + form + ' input[name="promo_code"]').val();
			}
			var linkerParam;
			var children = $('#' + form + ' select[name="child"]').val() ? $('#' + form + ' select[name="child"]').val() : $('#' + form + ' input[name="child"]').val();
			var adults = $('#' + form + ' select[name="adults"]').val() ? $('#' + form + ' select[name="adults"]').val() : $('#' + form + ' input[name="adults"]').val();
			var checkIn = $('#' + form + ' input[name="booking-checkin"]');
			var checkOut = $('#' + form + ' input[name="booking-checkout"]');
			var checkInVal = checkIn.val();
			var checkOutVal = checkOut.val();
			var checkInArray = checkInVal.split('/');
			var checkOutArray = checkOutVal.split('/');
			var checkInYear = checkInArray[2];
			var checkInMonth = parseInt(checkInArray[0]) - 1;
			var checkInMonthAdj = checkInArray[0];
			var checkInDay = checkInArray[1];
			var checkOutYear = checkOutArray[2];
			var checkOutMonth = parseInt(checkOutArray[0]) - 1;
			var checkOutDay = checkOutArray[1];
			//calculate number of days chosen
			var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
			var checkInDate = new Date(checkInYear, checkInMonth, checkInDay);
			var checkOutDate = new Date(checkOutYear, checkOutMonth, checkOutDay);
			var numDays = Math.round(Math.abs((checkInDate.getTime() - checkOutDate.getTime()) / oneDay));
			if (!$('#booking-form').length) {
				//validation
				if (checkInDate >= checkOutDate) {
					alert('Your Check-out day must be after your Check-in day. Please check your selection and try again.');
					return false;
				}
			}
			ga(function (tracker) {
				linkerParam = tracker.get('linkerParam');
			});
			var bookingURL =
				'https://www.bookonthenet.net/east/premium/eresmain.aspx?id=m0BVYhd2UTQITWeJuGbdV1aJ81twCjlWNx7wEQVOeo4%3d&_ga=2.185095657.1199375529.1662670897-2022576366.1655136865&arrival_date=' +
				checkInYear +
				'-' +
				checkInMonthAdj +
				'-' +
				checkInDay +
				'&stay_nights=' +
				numDays +
				'&promo_code=' +
				promoCode +
				'&adults=' +
				adults +
				'&children=' +
				children +
				'&' +
				linkerParam;
			console.log(bookingURL);
			window.open(bookingURL, '_blank');
		});

		// Main Nav Dropdown
		$('#primary-nav li').hover(
			function () {
				$(this).addClass('hover');
				$('ul.submenu', this).fadeIn(200);
			},
			function () {
				$(this).removeClass('hover');
				$('ul.submenu', this).fadeOut(200);
			}
		);

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date) {
			let d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val());
			let d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val());
			if ((d1 && date.getTime() == d1.getTime()) || (d2 && date.getTime() == d2.getTime())) {
				DATE_STYLE[1] = 'highlight-top';
			} else if (date > d1 && date < d2) {
				DATE_STYLE[1] = 'highlight';
			} else {
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = $('#CheckIn').data('format') !== undefined && $('#CheckIn').data('format') ? $('#CheckIn').data('format') : 'yy-mm-dd';
		$('#CheckIn').datepicker({
			changeMonth: true,
			dateFormat: DATE_FORMAT,
			numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$('#CheckOut').datepicker('setDate', newDate);
				$('#CheckOut').datepicker('option', 'minDate', selectedDate);
			},
		});
		$('#CheckOut').datepicker({
			dateFormat: DATE_FORMAT,
			changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
		});
	});

	window.onload = function () {
		scrollW();
		window.addEventListener('scroll', function () {
			scrollW();
		});
	};
	if (document.getElementsByClassName('footer') != null) {
        var submitSignUp = document.getElementById("email-signup").getElementsByClassName("signup-btn ")[0];
        submitSignUp.setAttribute('aria-label', 'Subscribe to our email database');
    }

	if (document.getElementById('form_id-2053') != null) {
        var submitBtn = document.getElementById("form_id-2053").getElementsByClassName("btn")[0];
        submitBtn.setAttribute('aria-label', 'Submit Form');
    }

})();

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	let bodyId = document.getElementsByTagName('body')[0].id;
	if (st > 10 || document.getElementById('header').classList.contains('header_alt')) {
		// downscroll code
		if (!document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.add('down');
		}
		var logoUrl = site_url + 'assets/svg/logo-scroll.svg';
		document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src', logoUrl);
	} else {
		if (document.getElementById('header').classList.contains('header_alt') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('down');
		}
		var logoUrl = site_url + 'assets/svg/logo.svg';
		document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src', logoUrl);
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
